import type { MatchCalendarDate, RoundPhase } from '@shared-types/match.types';
import { loadFromAPIs } from '@utilities/fetch';
import { apiKey, domesticApiUrl, matchApiUrl } from '@utilities/WindowContext';

export const fetchMatchDomesticDates = async (
  {
    competitionId,
    seasonYear,
  }: {
    competitionId: string;
    seasonYear: string;
  },
  signal?: AbortSignal,
) =>
  (
    await loadFromAPIs<{ data: MatchCalendarDate[] }>(
      'v2/match-calendar',
      { competitionId, seasonYear },
      { apiKey, apiUrl: domesticApiUrl, signal },
    )
  )?.data ?? [];

export const fetchMatchDates = async (
  params: {
    startDate: string;
    endDate: string;
    utcOffset: number;
    competitionIds?: string | string[];
    seasonYear?: string;
    roundId?: string;
    phase?: RoundPhase | 'ALL';
  },
  signal?: AbortSignal,
) =>
  (
    await loadFromAPIs<{ data: MatchCalendarDate[] }>('v5/match-calendar', params, {
      apiKey,
      apiUrl: matchApiUrl,
      signal,
    })
  )?.data ?? [];
